import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const ACCOUNT_TYPE = ['Law firm', 'Chamber', 'Solicitor', 'Barrister']

export const useAccountsCreation = () => {
  const [selectedType, setSelectedType] = useState<any>('')
  const navigate = useNavigate()

  const onSelectedType = useCallback(
    (type: string) => setSelectedType(type),
    [],
  )

  const onSelectedTypeAction = useCallback(() => {
    if (selectedType === '') return
    navigate(`/accounts/${selectedType.toLowerCase().replace(' ', '-')}`)
  }, [selectedType])

  const onBarristerCreation = useCallback((data) => {}, [])

  return {
    selectedType,
    onSelectedType,
    onSelectedTypeAction,
    onBarristerCreation,
  }
}
